import React from "react";

type Props = {};

const FeatureTracking = (props: Props) => {
  return <div>FeatureTracking</div>;
};

export default FeatureTracking;
